var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarWorkProgress = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.4004,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_34080_83397)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.7897 4.0482C10.8789 4.20179 9.97522 4.62684 9.268 5.23762C8.3679 6.01985 7.74997 7.12355 7.56066 8.29868C7.4928 8.71301 7.4928 9.5631 7.56066 9.97744C7.71068 10.9097 8.12858 11.7991 8.75008 12.5206C9.53231 13.4207 10.6324 14.035 11.8111 14.2279C12.2219 14.2958 13.0756 14.2958 13.4899 14.2279C14.465 14.0707 15.4223 13.6028 16.1581 12.9242C16.9903 12.1563 17.5582 11.099 17.7404 9.97744C17.8082 9.5631 17.8082 8.71301 17.7404 8.29868C17.5904 7.36643 17.1725 6.47705 16.551 5.75554C15.7687 4.85544 14.665 4.23751 13.4899 4.0482C13.097 3.98391 12.1719 3.98391 11.7897 4.0482ZM12.9363 6.11272C13.0041 6.15558 13.0899 6.24845 13.1291 6.31631C13.2006 6.43418 13.2042 6.50562 13.2149 7.67361L13.2292 8.90589L13.8542 9.40594C14.2007 9.6774 14.5114 9.95243 14.5472 10.0132C14.6365 10.156 14.6365 10.4096 14.5436 10.5596C14.3864 10.8204 14.0328 10.899 13.7828 10.7311C13.422 10.4846 12.2148 9.48095 12.1612 9.37737C12.104 9.27379 12.0969 9.13448 12.0969 7.8522C12.0969 6.4949 12.1005 6.43776 12.1719 6.31631C12.279 6.13415 12.4505 6.03057 12.6505 6.03057C12.7648 6.03057 12.8577 6.05557 12.9363 6.11272Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.3104 15.4925C5.51388 15.7247 4.91024 16.3426 4.70665 17.1284C4.63164 17.4142 4.63164 18.0071 4.70665 18.2964C4.91024 19.0822 5.59246 19.7609 6.36755 19.943C6.70687 20.0216 18.5868 20.0216 18.9297 19.943C19.7226 19.7573 20.387 19.0965 20.5941 18.2928C20.6691 18.0071 20.6691 17.4142 20.5941 17.1248C20.5156 16.8248 20.2905 16.4033 20.0798 16.164C19.8548 15.914 19.4726 15.6568 19.1404 15.5354L18.8832 15.4425L12.704 15.4354C6.91046 15.4282 6.51042 15.4318 6.3104 15.4925ZM10.6144 17.232C10.9966 17.457 10.9966 17.9642 10.6144 18.1893C10.493 18.2607 10.443 18.2643 8.64994 18.2643C6.85689 18.2643 6.80688 18.2607 6.68544 18.1893C6.23539 17.9285 6.33183 17.2963 6.83903 17.1713C6.89975 17.157 7.74984 17.1463 8.72138 17.1498C10.4359 17.157 10.493 17.1606 10.6144 17.232Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_34080_83397",
  x1: 6.90039,
  y1: 1,
  x2: 16.4004,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6D8B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D6E28D"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarWorkProgress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_work_progress.7c6e1e878f0642a6852755e97a327222.svg";